import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import TrackingRepositoriesFactory from '../Repositories/factory.js'

class MarkCsatNpsTriggeredTrackingUseCase extends UseCase {
  #repository

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create({config}) {
    return new MarkCsatNpsTriggeredTrackingUseCase({
      repository: TrackingRepositoriesFactory.sessionStorageCsatNpsRepository({config})
    })
  }

  @tracer({metric: 'MarkCsatNpsTriggeredTrackingUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    const storedState = await this.#repository.getState()

    return this.#repository.saveState({state: {...storedState, isTriggered: true}})
  }
}

export const factory = MarkCsatNpsTriggeredTrackingUseCase.create
